import { Component } from '@angular/core';

@Component({
  selector: 'app-why_us-type01',
  standalone: true,
  imports: [],
  templateUrl: './why_us-type01.component.html',
  styleUrl: './why_us-type01.component.scss'
})
export class WhyUsType01Component {

}
